"use strict";
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));
var _jsxRuntime = require("react/jsx-runtime");
const SvgIcon = (0, _createSvgIcon.default)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M480-424 364-308q-11 11-28 11t-28-11-11-28 11-28l116-116-116-115q-11-11-11-28t11-28 28-11 28 11l116 116 115-116q11-11 28-11t28 11q12 12 12 28.5T651-595L535-480l116 116q11 11 11 28t-11 28q-12 12-28.5 12T595-308z"
}), 'CloseSmallRounded', {
  viewBox: "0 -960 960 960"
});
var _default = exports.default = SvgIcon;